import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CardItem, Category, LikedItem } from './new-internet.model';

const UNCATEGORIZED = 'Uncategorized';

@Component({
    selector: 'app-ni-library',
    templateUrl: './library.component.html',
    styleUrls: ['./library.component.scss'],
    standalone: false
})
export class LibraryComponent {
  @Input() likes: LikedItem[] = [];
  @Input() categories: Category[] = [];
  @Input() readHashes = new Set<string>();
  @Input() search = '';
  @Output() open = new EventEmitter<LikedItem>();
  @Output() recategorize = new EventEmitter<LikedItem>();
  @Output() unlike = new EventEmitter<LikedItem>();

  activeCategory = '';   // '' = all

  get categoryNames(): string[] {
    const names = this.categories.map(c => c.name);
    if (this.likes.some(l => !l.category)) { names.push(UNCATEGORIZED); }
    return names;
  }

  get visibleLikes(): LikedItem[] {
    const q = this.search.trim().toLowerCase();
    return this.likes
      .filter(l => {
        const cat = l.category || UNCATEGORIZED;
        if (this.activeCategory && cat !== this.activeCategory) { return false; }
        if (q && !l.title.toLowerCase().includes(q) && !l.source.toLowerCase().includes(q)) {
          return false;
        }
        return true;
      })
      .sort((a, b) => b.likedAt - a.likedAt);
  }

  // Adapt a stored LikedItem to the FeedItemComponent's CardItem contract.
  toCard(like: LikedItem): CardItem {
    return {
      itemHash: like.itemHash, title: like.title, link: like.link,
      source: like.source, sourceType: like.sourceType, author: like.author,
      publishedAt: like.publishedAt, summary: like.summary, thumbnail: like.thumbnail,
      read: this.readHashes.has(like.itemHash), liked: true,
    };
  }

  trackByLikeId(_: number, like: LikedItem): string {
    return like.id;
  }
}
